import { render, staticRenderFns } from "./aprobados.vue?vue&type=template&id=6b47df10&scoped=true&"
import script from "./aprobados.vue?vue&type=script&lang=js&"
export * from "./aprobados.vue?vue&type=script&lang=js&"
import style0 from "./aprobados.vue?vue&type=style&index=0&id=6b47df10&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b47df10",
  null
  
)

export default component.exports